// import React from 'react';
// import { useLocation } from 'react-router-dom';
// import Sidebar from './Sidebar';
// import Topbar from './Topbar';
// import Toast from '../Common/Toast';
// import './Layout.css';

// const Layout = ({ children, toasts }) => {
//   const location = useLocation();
//   const currentPath = location.pathname.substring(1) || 'dashboard';
  
//   // Format the title (capitalize first letter of each word)
//   const formatTitle = (path) => {
//     const titles = {
//       'dashboard': 'Dashboard',
//       'members': 'Members',
//       'broadcast': 'Broadcast SMS',
//       'automation': 'Automation',
//       'birthdays': 'Birthdays & Anniversaries',
//       'polls': 'Polls & Feedback',
//       'inbox': 'SMS Inbox',
//       'attendance': 'Attendance',
//       'events': 'Events & RSVP',
//       'prayers': 'Prayer Wall',
//       'devotionals': 'Devotionals',
//       'drips': 'Drip Campaigns',
//       'visitors': 'Visitor Follow-up',
//       'giving': 'Giving Campaigns',
//       'chatbot': 'SMS Chatbot',
//       'health': 'Member Health Scoring',
//       'groups': 'Groups Manager',
//       'templates': 'Templates Library',
//       'msglog': 'Message Log',
//       'analytics': 'Analytics & Reports',
//       'import': 'Bulk Import',
//       'shortcode': 'Shortcode Setup',
//       'branches': 'Multi-Branch Manager',
//       'optout': 'Opt-Out Manager',
//       'notifications': 'Notifications',
//       'onboarding': 'Setup & Onboarding',
//       'billing': 'Billing',
//       'settings': 'Settings'
//     };
//     return titles[path] || path.charAt(0).toUpperCase() + path.slice(1);
//   };

//   return (
//     <div className="app">
//       <Sidebar />

//       <div className="main">
//         <Topbar title={formatTitle(currentPath)} />

//         <div className="content">
//           {children}
//         </div>
//       </div>

//       <Toast toasts={toasts} />
//     </div>
//   );
// };

// export default Layout;










// src/components/Layout/Layout.jsx
// import React from 'react';
// import { useLocation } from 'react-router-dom';
// import Sidebar from './Sidebar';
// import Topbar from './Topbar';
// import Toast from '../Common/Toast';
// import './Layout.css';

// const Layout = ({ children, toasts }) => {
//   const location = useLocation();
//   const currentPath = location.pathname.substring(1) || 'dashboard';
  
//   // Format the title (capitalize first letter of each word)
//   const formatTitle = (path) => {
//     const titles = {
//       'dashboard': 'Dashboard',
//       'members': 'Members',
//       'broadcast': 'Broadcast SMS',
//       'automation': 'Automation',
//       'birthdays': 'Birthdays & Anniversaries',
//       'polls': 'Polls & Feedback',
//       'inbox': 'SMS Inbox',
//       'attendance': 'Attendance',
//       'events': 'Events & RSVP',
//       'prayers': 'Prayer Wall',
//       'devotionals': 'Devotionals',
//       'drips': 'Drip Campaigns',
//       'visitors': 'Visitor Follow-up',
//       'giving': 'Giving Campaigns',
//       'chatbot': 'SMS Chatbot',
//       'health': 'Member Health Scoring',
//       'groups': 'Groups Manager',
//       'templates': 'Templates Library',
//       'msglog': 'Message Log',
//       'analytics': 'Analytics & Reports',
//       'import': 'Bulk Import',
//       'shortcode': 'Shortcode Setup',
//       'branches': 'Multi-Branch Manager',
//       'optout': 'Opt-Out Manager',
//       'notifications': 'Notifications',
//       'onboarding': 'Setup & Onboarding',
//       'billing': 'Billing',
//       'settings': 'Settings'
//     };
//     return titles[path] || path.charAt(0).toUpperCase() + path.slice(1);
//   };

//   return (
//     <div className="app-layout">
//       <Sidebar />
//       <div className="main-wrapper">
//         <Topbar title={formatTitle(currentPath)} />
//         <div className="content-wrapper">
//           {children}
//         </div>
//       </div>
//       <Toast toasts={toasts} />
//     </div>
//   );
// };

// export default Layout;









// src/components/Layout/Layout.jsx
// import React from 'react';
// import { useLocation } from 'react-router-dom';
// import Sidebar from './Sidebar';
// import Topbar from './Topbar';
// import Toast from '../Common/Toast';
// import './Layout.css';

// const Layout = ({ children, toasts = [] }) => {
//   const location = useLocation();
//   const currentPath = location.pathname.substring(1) || 'dashboard';
  
//   const formatTitle = (path) => {
//     const titles = {
//       'dashboard': 'Dashboard',
//       'members': 'Members',
//       'broadcast': 'Broadcast SMS',
//       'automation': 'Automation',
//       'birthdays': 'Birthdays & Anniversaries',
//       'polls': 'Polls & Feedback',
//       'inbox': 'SMS Inbox',
//       'attendance': 'Attendance',
//       'events': 'Events & RSVP',
//       'prayers': 'Prayer Wall',
//       'devotionals': 'Devotionals',
//       'drips': 'Drip Campaigns',
//       'visitors': 'Visitor Follow-up',
//       'giving': 'Giving Campaigns',
//       'chatbot': 'SMS Chatbot',
//       'health': 'Member Health Scoring',
//       'groups': 'Groups Manager',
//       'templates': 'Templates Library',
//       'msglog': 'Message Log',
//       'analytics': 'Analytics & Reports',
//       'import': 'Bulk Import',
//       'shortcode': 'Shortcode Setup',
//       'branches': 'Multi-Branch Manager',
//       'optout': 'Opt-Out Manager',
//       'notifications': 'Notifications',
//       'onboarding': 'Setup & Onboarding',
//       'billing': 'Billing',
//       'settings': 'Settings'
//     };
//     return titles[path] || path.charAt(0).toUpperCase() + path.slice(1);
//   };

//   return (
//     <div className="app-layout">
//       <Sidebar />
//       <div className="main-wrapper">
//         <Topbar title={formatTitle(currentPath)} />
//         <div className="content-wrapper">
//           {children}
//         </div>
//       </div>
//       <Toast toasts={toasts} />
//     </div>
//   );
// };

// export default Layout;










// src/components/Layout/Layout.jsx
// import React from 'react';
// import { useLocation } from 'react-router-dom';
// import Sidebar from './Sidebar';
// import Topbar from './Topbar';
// import Toast from '../Common/Toast';
// import './Layout.css';

// const Layout = ({ children, toasts = [] }) => {
//   const location = useLocation();
//   const currentPath = location.pathname.substring(1) || 'dashboard';
  
//   // Format the title (capitalize first letter of each word)
//   const formatTitle = (path) => {
//     const titles = {
//       'dashboard': 'Dashboard',
//       'members': 'Members',
//       'broadcast': 'Broadcast SMS',
//       'automation': 'Automation',
//       'birthdays': 'Birthdays & Anniversaries',
//       'polls': 'Polls & Feedback',
//       'inbox': 'SMS Inbox',
//       'attendance': 'Attendance',
//       'events': 'Events & RSVP',
//       'prayers': 'Prayer Wall',
//       'devotionals': 'Devotionals',
//       'drips': 'Drip Campaigns',
//       'visitors': 'Visitor Follow-up',
//       'giving': 'Giving Campaigns',
//       'chatbot': 'SMS Chatbot',
//       'health': 'Member Health Scoring',
//       'groups': 'Groups Manager',
//       'templates': 'Templates Library',
//       'msglog': 'Message Log',
//       'analytics': 'Analytics & Reports',
//       'import': 'Bulk Import',
//       'shortcode': 'Shortcode Setup',
//       'branches': 'Multi-Branch Manager',
//       'optout': 'Opt-Out Manager',
//       'notifications': 'Notifications',
//       'onboarding': 'Setup & Onboarding',
//       'billing': 'Billing',
//       'settings': 'Settings'
//     };
//     return titles[path] || path.charAt(0).toUpperCase() + path.slice(1);
//   };

//   return (
//     <div className="app-layout">
//       <Sidebar />
//       <div className="main-wrapper">
//         <Topbar title={formatTitle(currentPath)} />
//         <div className="content-wrapper">
//           {children}
//         </div>
//       </div>
//       <Toast toasts={toasts} />
//     </div>
//   );
// };

// export default Layout;












// src/components/Layout/Layout.jsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import Toast from '../Common/Toast';
import './Layout.css';

const Layout = ({ children, toasts = [] }) => {
  const location = useLocation();
  const currentPath = location.pathname.substring(1) || 'dashboard';
  
  const formatTitle = (path) => {
    const titles = {
      'dashboard': 'Dashboard',
      'members': 'Members',
      'broadcast': 'Broadcast SMS',
      'automation': 'Automation',
      'birthdays': 'Birthdays & Anniversaries',
      'polls': 'Polls & Feedback',
      'inbox': 'SMS Inbox',
      'attendance': 'Attendance',
      'events': 'Events & RSVP',
      'prayers': 'Prayer Wall',
      'devotionals': 'Devotionals',
      'drips': 'Drip Campaigns',
      'visitors': 'Visitor Follow-up',
      'giving': 'Giving Campaigns',
      'chatbot': 'SMS Chatbot',
      'health': 'Member Health Scoring',
      'groups': 'Groups Manager',
      'templates': 'Templates Library',
      'msglog': 'Message Log',
      'analytics': 'Analytics & Reports',
      'import': 'Bulk Import',
      'shortcode': 'Shortcode Setup',
      'branches': 'Multi-Branch Manager',
      'optout': 'Opt-Out Manager',
      'notifications': 'Notifications',
      'onboarding': 'Setup & Onboarding',
      'billing': 'Billing',
      'settings': 'Settings'
    };
    return titles[path] || path.charAt(0).toUpperCase() + path.slice(1);
  };

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-wrapper">
        <Topbar title={formatTitle(currentPath)} />
        <div className="content-wrapper">
          {children}
        </div>
      </div>
      <Toast toasts={toasts} />
    </div>
  );
};

export default Layout;